import { compose } from 'redux';

import type { UserAlertsState } from '../userAlertsStore';

export const selectUserAlertsDomain = (state: UserAlertsState) =>
  state.userAlerts;

export const selectUserAlertsPage = compose(
  (state) => state.alertWebData,
  selectUserAlertsDomain
);
